import useSWR from "swr";
import { Api } from "../api/Assinafy";

const useApiCache = (endpointName, args = [], swrOptions = {}) => {
  const key = endpointName ? `${endpointName}-${JSON.stringify(args)}` : null;
  const fetcher = async () => {
    const response = await Api(endpointName)(...args);
    return response;
  };

  // Configuração padrão: cache de 2 minutos, sem revalidação automática
  const defaultSwrOptions = {
    dedupingInterval: 120000, // 2 minutos - evita requisições duplicadas
    revalidateOnFocus: false, // Não revalida ao focar na janela
    revalidateOnReconnect: true, // Revalida ao reconectar
    revalidateIfStale: true, // Revalida se os dados estiverem stale
    ...swrOptions,
  };

  const {
    data: response,
    error,
    isLoading,
    isValidating,
    mutate,
  } = useSWR(key, fetcher, defaultSwrOptions);

  let data = null;
  if (response) {
    if (response?.data?.data !== undefined) {
      data = response.data.data;
    } else if (response?.data !== undefined) {
      data = response.data;
    } else {
      data = response;
    }
  }

  return {
    data, // Dados extraídos (response.data.data ou response.data)
    response, // Resposta completa do axios (útil para acessar status, headers, etc)
    error: error?.response || error,
    isLoading: isLoading && !data && !error,
    isValidating,
    mutate, // Função para invalidar/atualizar o cache manualmente
  };
};

export default useApiCache;
